import { render } from "./Attachments.vue?vue&type=template&id=508aee81&scoped=true&ts=true"
import script from "./Attachments.vue?vue&type=script&lang=ts"
export * from "./Attachments.vue?vue&type=script&lang=ts"

import "./Attachments.vue?vue&type=style&index=0&id=508aee81&scoped=true&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508aee81"]])

export default __exports__